import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

const ResponsiveRecordList = ({ items = [], renderItem }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1.5}>
      {items.map((item, index) => (
        <Card key={item?.id ?? index} variant="outlined">
          <CardContent sx={{ pb: '16px !important' }}>
            <Box>{renderItem(item, index)}</Box>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export const EmptyRecordsState = ({ message }) => (
  <Box py={5} textAlign="center">
    <Typography color="text.secondary">{message}</Typography>
  </Box>
);

export default ResponsiveRecordList;
